import axios from "axios";
import { Global } from '../utils/general';
import headerRequest from "../utils/headers"

const API_URL = Global.url;

class MailsService {
    recoveryPassword(usuario) {
        let ruta = `${API_URL}/mails/recovery-password/${usuario}`;
        return axios.post(ruta, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    }
}

export default new MailsService();
